import { showToast } from "utils/swalToast"

//config para traer la url
import config from "config"

async function fetchPost(data) {
  let url = `${config.api.baseURL}/sucursales`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-type": "application/json",
      Authorization: ` Bearer ${token}`,
    },
  })
    .then((r) => {
      if (r.ok) {
        // La respuesta es exitosa (200 OK) pero sin contenido, así que devolvemos solo el estado
        return { status: r.status, body: null }
      } else {
        // Si hay un error, lanzamos una excepción para manejarlo en el bloque .catch
        return r.json().then((data) => {
          throw new Error(data.error || "Error desconocido")
        })
      }
    })
    .then((response) => {
      const elem = document.getElementById("formAddUs")
      if (response.status === 200) {
        if (elem) {
          elem.reset()
        }
        showToast({ title: "Sucursal agregado exitosamente", icon: "success" })
        return response.body
      }
    })
    .catch((error) => {
      showToast({
        icon: "info",
        title: "Error",
        text: error.message,
      })
      throw error
    })
}

async function fetchSucursalById(id) {
  let url = `${config.api.baseURL}/sucursales/${id}`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Error al obtener los datos de la sucursal")
      }
      return response.json()
    })
    .catch((error) => {
      showToast({
        icon: "error",
        title: "Error",
        text: error.message,
      })
      throw error
    })
}

async function fetchServiciosBySucursalId(id) {
  let url = `${config.api.baseURL}/sucursales/${id}/servicios`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Error al obtener los servicios de la sucursal")
      }
      return response.json()
    })
    .catch((error) => {
      showToast({
        icon: "error",
        title: "Error",
        text: error.message,
      })
      throw error
    })
}

async function updateSucursal(id, data) {
  let url = `${config.api.baseURL}/sucursales/${id}`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "PUT",
    body: JSON.stringify(data),
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then(async (response) => {
      if (!response.ok) {
        const error = await response.json()
        showToast({
          icon: "error",
          title: "Error al actualizar",
          text: error.message || "No se pudo actualizar la sucursal",
        })
        throw new Error(error.message || "No se pudo actualizar la sucursal")
      } else {
        return response.json()
      }
    })
    .catch((error) => {
      showToast({
        icon: "error",
        title: "Error",
        text: error.message,
      })
      throw error
    })
}

async function fetchAllServicios() {
  let url = `${config.api.baseURL}/servicios`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response?.ok) {
        throw new Error("Error al obtener los datos de servicios")
      }
      return response.json()
    })
    .catch((error) => {
      showToast({
        icon: "error",
        title: "Error",
        text: error.message,
      })
      throw error
    })
}

async function fetchAllWatchlist() {
  let url = `${config.api.baseURL}/watchlist`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response?.ok) {
        showToast({
          icon: "error",
          title: "Error",
          text: "No se puede conectar con Corsight. Contacte con el soporte tecnico.",
        })
        return []
      }
      return response.json()
    })
    .catch((error) => {
      showToast({
        icon: "error",
        title: "Error",
        text: error.message,
      })
      return []
    })
}

async function updateServicios(id, data) {
  let url = `${config.api.baseURL}/sucursales/${id}/servicios`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "PUT",
    body: JSON.stringify(data),
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response?.ok) {
        return response.json().then((error) => {
          showToast({
            icon: "error",
            title: "Error al actualizar",
            text: error.message || "No se pudo actualizar la sucursal",
          })
          throw new Error(error.message || "No se pudo actualizar la sucursal")
        })
      } else {
        return response.json()
      }
    })
    .catch((error) => {
      showToast({
        icon: "error",
        title: "Error",
        text: error.message,
      })
      throw error
    })
}

async function fetchEmpresa() {
  let url = `${config.api.baseURL}/empresas`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    if (!response.ok) {
      throw new Error("Error al obtener las empresas")
    }
    return await response.json()
  } catch (error) {
    showToast({
      icon: "error",
      title: "Error",
      text: error.message,
    })
    throw error
  }
}

async function fetchColumnas(id, modulo) {
  let url = `${config.api.baseURL}/sucursales/${id}/columnas?modulo=${encodeURIComponent(modulo)}`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Error al obtener las columnas")
      }
      return response.json()
    })
    .catch((error) => {
      showToast({ icon: "error", title: "Error", text: error.message })
      throw error
    })
}

async function updateColumnas(id, data) {
  let url = `${config.api.baseURL}/sucursales/${id}/columnas`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "PUT",
    body: JSON.stringify(data),
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then(async (response) => {
      if (!response.ok) {
        const error = await response.json()
        showToast({
          icon: "error",
          title: "Error al guardar",
          text: error.message || "No se pudo guardar la configuración",
        })
        throw new Error(error.message || "No se pudo guardar la configuración")
      }
      return response.json()
    })
    .catch((error) => {
      showToast({ icon: "error", title: "Error", text: error.message })
      throw error
    })
}

async function deleteColumnas(id, modulo) {
  let url = `${config.api.baseURL}/sucursales/${id}/columnas?modulo=${encodeURIComponent(modulo)}`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "DELETE",
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then(async (response) => {
      if (!response.ok) {
        const error = await response.json()
        showToast({
          icon: "error",
          title: "Error al restablecer",
          text: error.message || "No se pudo restablecer la configuración",
        })
        throw new Error(error.message || "No se pudo restablecer la configuración")
      }
      return response.status === 204 ? null : response.json()
    })
    .catch((error) => {
      showToast({ icon: "error", title: "Error", text: error.message })
      throw error
    })
}

async function fetchCatalogoConfiguraciones(scope) {
  let url = `${config.api.baseURL}/configuraciones-aplicadas/catalogo`
  if (scope) {
    url += `?scope=${encodeURIComponent(scope)}`
  }
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response?.ok) {
        throw new Error("Error al obtener el catalogo de parametros")
      }
      return response.json()
    })
    .catch((error) => {
      showToast({ icon: "error", title: "Error", text: error.message })
      throw error
    })
}

async function fetchDiccionarioBySucursalId(id) {
  let url = `${config.api.baseURL}/configuraciones-aplicadas/sucursal/${id}`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response?.ok) {
        throw new Error("Error al obtener el diccionario de la sucursal")
      }
      return response.json()
    })
    .catch((error) => {
      showToast({ icon: "error", title: "Error", text: error.message })
      throw error
    })
}

async function updateDiccionarioSucursal(id, data) {
  let url = `${config.api.baseURL}/configuraciones-aplicadas/sucursal/${id}`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "PUT",
    body: JSON.stringify(data),
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response?.ok) {
        return response.json().then((error) => {
          throw new Error(error.message || "No se pudo guardar el diccionario")
        })
      }
      return response.json()
    })
    .catch((error) => {
      showToast({ icon: "error", title: "Error", text: error.message })
      throw error
    })
}

export { fetchEmpresa }

export { updateSucursal }

export { fetchSucursalById }

export { fetchPost }

export { fetchAllWatchlist, fetchAllServicios, updateServicios }

export { fetchServiciosBySucursalId }

export { fetchColumnas, updateColumnas, deleteColumnas }

export { fetchCatalogoConfiguraciones, fetchDiccionarioBySucursalId, updateDiccionarioSucursal }
